{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Zobacz wszystkie opcje",
  "Spoiler_Reveal_Tooltip": "Kliknij, aby pokazać",
  "VerticalEmbed_Event_Error_Subtitle": "To wydarzenie zostało usunięte, zastąp je innym wydarzeniem.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweetnij to",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Element jest zwinięty",
  "Spoiler_Reveal_Video_CTA": "Pokaż film",
  "VerticalEmbed_Pricing_Plan": "Tylko plan",
  "Image_Expand_Button_AriaLabel": "Rozwiń obraz",
  "VerticalEmbed_From_Price": "Od",
  "Poll_Viewer_ShowAllResults_CTA": "Zobacz wszystkie wyniki",
  "Spoiler_Reveal_Image_Placeholder": "Ten obraz zawiera spoiler",
  "VerticalEmbed_Ribbon": "Rabat",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Suwak wyszukiwania",
  "VerticalEmbed_Error_Subtitle": "Ten element został usunięty, zastąp go innym elementem.",
  "Poll_Viewer_Multiselect_Footer": "Możesz głosować na więcej niż jedną odpowiedź.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Pokaż więcej elementów sterujących dźwiękiem",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Nie można załadować usługi",
  "Fullscreen_Close_Button_AriaLabel": "Zamknij",
  "VerticalEmbed_Event_Fetch_Error_Title": "Nie można załadować wydarzenia",
  "UploadFile_Viewer_Loader": "Ładowanie {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Awatar użytkownika",
  "Preview_ReadMore_Label": "Przeczytaj więcej",
  "Spoiler_Insert_Tooltip": "Spojler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Nie można załadować produktu",
  "Fullscreen_Shrink_Button_AriaLabel": "Zmniejsz",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Ilość",
  "Spoiler_Reveal_Gallery_Placeholder": "Ta galeria zawiera spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Rozszerz",
  "VerticalEmbed_Bookings_Button": "Zarezerwuj teraz",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Wyłącz wyciszenie",
  "Spoiler_Reveal_Gallery_CTA": "Pokaż galerię",
  "Poll_Viewer_ShowLess_CTA": "Pokaż mniej",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Wycisz",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonimowych",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Obserwuj",
  "VerticalEmbed_Products_Button": "Kup teraz",
  "Poll_Viewer_Toast_Error_ServerDown": "Nie można połączyć się z serwerem. Spróbuj ponownie później.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} osoba głosowała na tę odpowiedź",
  "Poll_Viewer_VoteCount": "{{number}} głosy(ów)",
  "VerticalEmbed_Events_Button": "Zarejestruj się teraz",
  "Spoiler_Reveal_Image_CTA": "Pokaż obraz",
  "Poll_Viewer_Toast_Error_Connection": "Brak internetu. Sprawdź połączenie.",
  "Poll_Viewer_Visibility_Owner_Footer": "Tylko ty możesz zobaczyć wyniki.",
  "VerticalEmbed_Booking_Error_Title": "Usługa została usunięta",
  "VerticalEmbed_Product_Error_Title": "Produkt został usunięty",
  "VerticalEmbed_Fetch_Error_Subtitle": "Nie można załadować informacji o elemencie.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} osób głosowało na tę odpowiedź",
  "VerticalEmbed_Event_Error_Title": "Wydarzenie zostało usunięte",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Element jest rozwinięty",
  "Audio_Plugin_Cover_Alt": "Okładka audio",
  "Spoiler_Reveal_Video_Placeholder": "Ten film zawiera spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Wystąpił problem techniczny. Sprawdź połączenie i spróbuj ponownie.",
  "VerticalEmbed_Fetch_Error_Title": "Nie udało się załadować elementu",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Ten produkt został usunięty, zastąp go innym produktem.",
  "VerticalEmbed_Booking_Error_Subtitle": "Ta usługa została usunięta, zastąp ją inną usługą.",
  "Preview_SeeFullPost_Label": "Zobacz cały post",
  "UploadFile_Viewer_Download": "Pobierz {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}h",
  "VerticalEmbed_Units_Minute": "{{minutes}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Wystąpił problem techniczny. Sprawdź połączenie i spróbuj ponownie.",
  "VerticalEmbed_Error_Button": "Zastąp",
  "VerticalEmbed_Error_Title": "Element został usunięty",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Wystąpił problem techniczny. Sprawdź połączenie i spróbuj ponownie.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
